import styled from "styled-components";
import { Card, Steps } from "antd";

export const layout = {
  //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    height: auto;
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;
export const CardStyle = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px;
  width: 700px;

  @media (max-width: 768px) {
    width: 100%;
    margin: 10px;
    height: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin: 0px;
    height: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
`;
export const StepsStyle = styled(Steps)`
  width: 100%;

  @media (max-width: 768px) {
    .ant-steps-horizontal.ant-steps {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .ant-steps-item {
      flex: 1 1 25%;
      text-align: center;
    }
  }
`;

export const ContainerForm = styled.div`
  width: 100%;
  height: 280px;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 16px;

  @media (max-width: 768px) {
    padding: 0 12px;
    height: 550px; /* ALTERADO */
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  @media (max-width: 480px) {
    padding: 0 8px;
    height: 550px; /* ALTERADO */
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5%;
  margin-bottom: 5%;
`;

export const MensagemSucesso = styled.div`
  flex: 1;

  p:first-child {
    font-weight: 600;
    font-size: 1.125rem; /* text-lg */
  }

  p:last-child {
    font-size: 0.875rem; /* text-sm */
  }
`;
